import { render } from "./EditPagePreview.vue?vue&type=template&id=4c5ad5bd&scoped=true"
import script from "./EditPagePreview.vue?vue&type=script&lang=js"
export * from "./EditPagePreview.vue?vue&type=script&lang=js"

import "./EditPagePreview.vue?vue&type=style&index=0&id=4c5ad5bd&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c5ad5bd"]])

export default __exports__